import React from 'react';
import {DemandInfo} from 'components/demand';
import {Textarea} from 'components/vitrade-forms/common';
import {Link} from 'react-router-dom';
import {DemandConversationsContainer} from 'components/demand';
import {Demands} from 'api';
import {connect} from 'react-redux';
import {
  CreateConversationForm,
  ConversationItem,
  SendMessageForm,
  ConversationContainer
} from 'components/conversations';

class MybusinessNeedOfferDetail extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataBusiness: [
        {id: 1},
        {id: 1},
        {id: 1}
      ]
    };
  }

  loadConversation() {
    this.props.dispatch(Demands.actions.getConversationByBusiness({
      id: this.props.id,
      businessId: this.props.mainBusiness.id
    }))
    .then(response => {
      this.setState({
        conversation: response.data
      })
    });
  }

  componentDidMount() {
    this.loadConversation();
  }
  //
  // loadConversations() {
  //   Promise.all([
  //     Demands.actions.listConversations.request({
  //       id: this.props.demand.id,
  //       filter: {
  //         limit: 100
  //       }
  //     }),
  //     Demands.actions.hasOwnConversation.request({
  //       id: this.props.demand.id
  //     })
  //   ]).spread((conversations, hasOwnConversation) => {
  //     this.setState({
  //       conversations: conversations.data,
  //       hasOwnConversation: hasOwnConversation.data
  //     })
  //   })
  // }

  onConversationCreate() {
    this.loadConversation();
  }

  render() {
    return (
      <section className='need-offer-container need-offer-list-business-container mb35'>
        <h2 className='need-offer-title'>Chi tiết nhu cầu</h2>
        <DemandInfo {...this.props}/>
        {/* <DemandConversationsContainer demand={this.props}/> */}

        {
          this.state.conversation &&
          <ConversationContainer
            view="BUSINESS"
            conversation={this.state.conversation}
          />
        }

        {
          this.state.conversation &&
          <SendMessageForm
            conversation={this.state.conversation}
          />
        }

        {
          !this.state.conversation &&
          <CreateConversationForm
            data={
              {
                demandId: this.props.id,
                tenderIds: [
                  this.props.userId
                ]
              }
            }
            type={this.props.type}
            onConversationCreate={this.onConversationCreate.bind(this)}
          />
        }

      </section>
    );
  }
}

const bindStateToProps = (state) => {
  return {
    user: state.auth && state.auth.user,
    mainBusiness: state.myBusinesses.mainBusiness && state.myBusinesses.mainBusiness
  }
}

export default connect(bindStateToProps)(MybusinessNeedOfferDetail);



// WEBPACK FOOTER //
// ./components/my-business/MybusinessNeedOfferDetail.jsx